<nav class="navbar navbar-expand-lg navbar-dark bg-secondary">
  <a class="navbar-brand" href="/">UpBoards</a>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
    aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav mr-auto" *ngIf="authService.isLoggedIn">
      <li>
        <a class="nav-link" [routerLink]=" [ '/account' ]">My Account</a>
      </li>
      <li *ngIf="boardId && !isAccountPage()">
        <a class="nav-link" [routerLink]=" [ '/boards', boardId, 'view' ]">View Mode</a>
      </li>
      <li *ngIf="boardPermissions.userHasEditPermissions(boardPermissions.boardUser) && !isAccountPage()">
        <a class="nav-link" [routerLink]=" [ '/boards', boardId ]">Manage Board</a>
      </li>
      <li *ngIf="boardPermissions.userHasEditPermissions(boardPermissions.boardUser) && !isAccountPage()">
        <a class="nav-link" [routerLink]=" [ '/boards', boardId, 'admin' ]">Board Admin</a>
      </li>
      <li *ngIf="boardPermissions.userHasAdminPermissions(boardPermissions.boardUser) && !isAccountPage()">
        <a class="nav-link" [routerLink]=" [ '/boards', boardId, 'admin-token' ]">Change Admin Token</a>
      </li>
    </ul>
    <div class="nav-right">
      <a class="nav-link" [routerLink]=" [ '/contact' ]">Contact Info</a>
      
      <!-- User Section -->
      <div class="user-section" *ngIf="authService.isLoggedIn">
        <a [routerLink]="[ '/account' ]" class="user-info">
          <img *ngIf="authService.userData.photoURL" 
               [src]="authService.userData.photoURL" 
               class="user-avatar" 
               alt="User avatar" />
          <span class="user-email">{{ authService.userData.email }}</span>
        </a>
        <a class="nav-link logout-link" (click)="authService.SignOut()">Log Out</a>
      </div>
      
      <a *ngIf="!authService.isLoggedIn" class="nav-link" [routerLink]=" [ '/signin' ]">Sign In</a>
    </div>
  </div>
</nav>